import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import { Link, useLocation } from "react-router-dom";
import paginationValue from "../common/paginationValue.json";
import Pagination from "../components/Layout/Pagination";
import aldotImg from "../assets/WAH-Logo-ALDOT-Approved.png";
import WorkTypeFilter from "../components/Filters/WorkTypeFilter";
import UploadingRequest from "./UploadingRequest";
import axios from "axios";
import AxiosInstance from "../utils/axiosInstance";
import toast from "react-hot-toast";
import loader from "../assets/loader.svg";
import favoriteImg from "../assets/bookmark-favorite.svg";
import MRBLOGO from "../assets/KMT_Logo_WhiteBG.png";

import OptInModel from "../components/Model/OptInModel";
import ViewPlanHolderModel from "../components/Model/ViewPlanHolderModel";
import SeeRecordsModel from "../components/Model/SeeRecordsModel";
import AdvertiseForHelpModel from "../components/Model/AdvertiseForHelpModel";
import PrimeContractorHelpModel from "../components/Model/PrimeContractorHelpModel";
import { getLabelsFromWorktypes, getFormattedDate } from "../utils/helper";
import searchIcon from "../assets/search-icon.svg";

function DesignBuildPage() {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(paginationValue.currentPage);
  const [workTypeId, setWorkTypeId] = useState("");
  const [resetTrue, setResetTrue] = useState(false);
  const [pageLimit, setPageLimit] = useState(paginationValue.limit);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState();
  const [desingList, setDesignList] = useState([]);
  const [APICall, setAPICAll] = useState(true);
  const [favloader, setFavloader] = useState(false);
  const abortControllerRef = useRef(null);
  const [showloader, setloader] = useState(false);
  const [selectedState, setSelectedState] = useState(
    JSON.parse(localStorage.getItem("selectedState")) || null
  );
  const isFirstRender = useRef(true);
  const [isLoading, setIsLoading] = useState(false); // Add isLoading

  const [categoryObject, setCategoryObject] = useState(
    location.state?.category || { label: "WAH", value: "DESIGN_BUILD_WAH" }
  );
  const [searchValue, setSearchValue] = useState("");

  const [modelOpen, setModelOpen] = useState(false);
  const [modelOpenViewPlan, setModdelOpenViewPlan] = useState(false);
  const [modelOpenOptIN, setModelOpenOptIN] = useState(false);
  const [modelSeeRecords, setModelSeeRecords] = useState(false);
  const [modelAdvertiseForHelp, setModelAdvertiseForHelp] = useState(false);
  const [PrimeContractorHelp, setModelPrimeContractorHelp] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [isAddOnDashboard, setAddOnDashboard] = useState(0);

  useEffect(() => {
    // Load the data from localStorage on component mount
    const savedDashboardData =
      JSON.parse(localStorage.getItem("add_to_dashboard")) || [];

    const dashboardStatusMap = savedDashboardData.reduce((acc, item) => {
      acc[item.name] = item.status;
      return acc;
    }, []);

    setAddOnDashboard(
      dashboardStatusMap[categoryObject.label.toLowerCase()] || 0
    );
  }, []);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const addToDashboardApi = (page_type) => {
    setIsLoading(true);
    const payload = {
      page_type: page_type,
    };
    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_ADD_TO_DASHBOARD}`,
      payload
    )
      .then((response) => {
        setloader(false);
        toast.success(response.data?.message);

      
        // Assuming the response contains 'id', 'name', and 'status' as shown in your example:
        const { id, name, status } = response.data.data;
     
        // Get current data from localStorage
        const existingData =
          JSON.parse(localStorage.getItem("add_to_dashboard")) || [];

       
        const entryIndex = existingData.findIndex((item) => item.name === name);

        if (entryIndex !== -1) {
          existingData[entryIndex].status = status;
        } else {
          const newEntry = {
            id: id,
            name: name,
            status: status,
          };
          existingData.push(newEntry);
        }

        localStorage.setItem("add_to_dashboard", JSON.stringify(existingData));
        setAddOnDashboard((pre) => !pre);
        setIsLoading(false);
  
      })
      .catch((error) => {
        console.error(error);
        toast.error(error?.message);
        setIsLoading(false);
      });
  };
  
  const handleWorkTypeSelect = (workType) => {
    setWorkTypeId(workType);
    setCurrentPage(1);
    setResetTrue(false);
    setAPICAll(true);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleReset = () => {
    setResetTrue(true);
    setCurrentPage(1);
    setWorkTypeId("");
    setSearchValue("");
    setAPICAll(true);
  };

  useEffect(() => {
    if (APICall) {
      getDesignList();
      setAPICAll(false);
    }
  }, [APICall]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    getDesignList();
  }, [currentPage]);
  const getDesignList = async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    setAPICAll(false);
    setloader(true);

    const controller = new AbortController();
    abortControllerRef.current = controller;
    const queryParams = new URLSearchParams({
      page_type: "DESIGN_BUILD",
      page: currentPage,
      limit: pageLimit,
      report_id: workTypeId,
      design_build_category: categoryObject.value.toUpperCase(),
      state_id: selectedState?.value,
      search_text: searchValue,
    });

    const currentTime = new Date().getTime();
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_PROJECT}?currentTime=${currentTime}&${queryParams}`,
        { signal: controller.signal }
      );

      if (response.data?.data?.length > 0) {
        const updatedDesignList = await Promise.all(
          response.data.data.map(async (item) => {
            if (item.worktypes) {
              const worktypeLabels = await getLabelsFromWorktypes(
                item.worktypes
              );
              return { ...item, worktypeLabels };
            }
            return item;
          })
        );

        setDesignList(updatedDesignList);
        setPageLimit(response.data.limit);
        setTotalRecords(response.data.total_records);
        setTotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        toast.success(response.data?.message);
      } else {
        setDesignList([]);
        toast.success("No projects found.");
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        toast.error(error?.message);
      }
    } finally {
      setloader(false);
    }
  };

  const addFav = (account_Id, favorite) => {
    setloader(true);
    const payload = {
      project_id: account_Id,
      type: "DESIGN_BUILD",
      action: favorite,
      state_id: selectedState?.value,
    };

    AxiosInstance.post(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_ADD_FAVORITE}`,
      payload
    )
      .then((response) => {
        setloader(false);
        toast.success(response.data?.message);
        // getDirectoryList();
        setDesignList((prevList) =>
          prevList.map((item) =>
            item.project_id === account_Id
              ? { ...item, favorites: item.favorites === "0" ? "1" : "0" }
              : item
          )
        );
      })
      .catch((error) => {
        toast.error(error?.message);
        setloader(false);
      });
  };

  const handleAPIcall = () => {
    setAPICAll(true);
  };
  const handleModelOpenOptIN = (callid, ccnCallId) => {
    setAPICAll(false);
    setSelectedData(callid);
    setSelectedProjectId(ccnCallId);
    setModelOpenOptIN(true);
  };

  const handleModelOpenSeeRecords = (callid, project_id) => {
    //   setSelectedData(callid);
    setSelectedProjectId(project_id);
    setModelSeeRecords(true);
  };

  const handleModelOpenAdvertiseForHelp = (callId, project_id) => {
    setModelAdvertiseForHelp(true);
    setSelectedProjectId(project_id);
    //  setSelectedData(callId);
  };
  const handleModelOpenPrimeContractorHelpModel = (project_id, callId) => {
    setSelectedProjectId(project_id);
    //    setSelectedData(callId);
    setModelPrimeContractorHelp(true);
  };

  const handleModelClose = () => setModelOpen(false);
  const handleModelCloseViewPlan = () => setModdelOpenViewPlan(false);
  const handleModelCloeseOpenOptIN = () => {
    setModelOpenOptIN(false);
  };
  const handleModelCloeseSeeRecords = () => setModelSeeRecords(false);
  const handleModelCloeseAdvertiseForHelp = () => {
    setModelAdvertiseForHelp(false);
  };

  const handleModelCloesePrimeContractorHelp = () =>
    setModelPrimeContractorHelp(false);
  const handleSearchClick = () => {
    setCurrentPage(1);
    setAPICAll(true);
  };
  return (
    <>
      <Header />

      <div className={`bg-primary pt-5 ${activeTab !== 1 ? "pb-20" : ""}`}>
        <div className="container">
          <div className="row">
            <div className="col col-md-auto bg-primary mb-3">
              <p className="text-white point-22">Bid Opportunities</p>
              {activeTab === 0 ? (
                <h1 className="text-secondary fw-boldest point-42">
                  {categoryObject.label.toUpperCase()}
                </h1>
              ) : (
                <h1 className="text-secondary fw-boldest point-42">
                  {" "}
                  Uploading Request{" "}
                </h1>
              )}
              <div className="dotPage">
                <ul className="nav nav-tabs align-items-center">
                  {activeTab === 1 && (
                    <>
                      <li className="nav-item">
                        <Link
                          className={`nav-link fw-bolder text-uppercase point-16 ${
                            activeTab === 0 ? "text-white" : "text-secondary"
                          }`}
                          title="Forms"
                          onClick={() => handleTabClick(0)}
                        >
                          {categoryObject.label.toUpperCase()}
                        </Link>
                      </li>
                      <li className="nav-item">
                        <span className="point-16 fw-bolder text-danger mx-2">
                          |
                        </span>
                      </li>
                    </>
                  )}

                  <li className="nav-item">
                    <Link
                      className={`nav-link fw-bolder text-uppercase point-16 ${
                        activeTab === 1 ? "text-white" : "text-secondary"
                      }`}
                      onClick={() => handleTabClick(1)}
                      title="uploadingRequest"
                    >
                      Advertise for sub-quotes
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {activeTab !== 1 && (
              <>
                <div
                  className="dotPage col align-self-end mb-3 text-center"
                  style={{ marginLeft: "20%" }}
                >
                  <ul className="nav nav-tabs align-items-center justify-content-end">
                    <li className="nav-item">
                      <Link
                        to="/directory"
                        className="nav-link fw-bolder text-uppercase point-16 text-secondary"
                        title="Directory"
                      >
                        DBE Directory
                      </Link>
                    </li>
                    <span className="point-16 fw-bolder text-danger mx-2">
                      |
                    </span>
                    <li className="nav-item">
                      {(() => {
                        const href =
                          categoryObject.value === "DESIGN_BUILD_BAYWAY"
                            ? "#"
                            : categoryObject.value === "DESIGN_BUILD_WAH"
                            ? "https://westalabamahighway.com/"
                            : "https://mobileriverbridge.com/";

                        const target = href === "#" ? "_self" : "_blank";

                        return (
                          <a
                            href={href}
                            className="nav-link fw-bolder text-uppercase point-16 text-secondary"
                            target={target}
                            rel="noopener noreferrer"
                          >
                            B&G
                          </a>
                        );
                      })()}
                    </li>
                  </ul>
                </div>

                {categoryObject.value !== "DESIGN_BUILD_BAYWAY" && (
                  <div className="col col-md-2 text-end">
                    <a
                      href={
                        categoryObject.value === "DESIGN_BUILD_WAH"
                          ? "https://westalabamahighway.com/"
                          : "https://mobileriverbridge.com/ "
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={
                          categoryObject.value === "DESIGN_BUILD_WAH"
                            ? aldotImg
                            : MRBLOGO
                        }
                        width="160px"
                        alt={categoryObject.value}
                        style={{ cursor: "pointer" }}
                      />
                    </a>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {activeTab === 0 && (
        <>
          <div className="bg-white py-3">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                    <div className="card-body p-3">
                      <div className="row">
                        <div className="col-12 col-md-auto">
                          <span
                            className="input-group-text ps-0 ms-0 text-uppercase text-secondary fw-bold border-0 bg-white rounded-0"
                            id="basic-addon1"
                          >
                            Filter:
                          </span>
                        </div>
                        <div className="col-12 col-md">
                          <div className="input-group mb-3">
                            <div style={{ width: "100%" }}>
                              <WorkTypeFilter
                                onSelectWorkType={handleWorkTypeSelect}
                                reset={resetTrue}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-3">
                          <div className="input-group mb-3">
                            <input
                              type="text"
                              className="form-control fw-bolder text-white bg-secondary rounded-0 border border-1 border-secondary placeholder-white point-18"
                              placeholder="Search"
                              aria-label="Search"
                              aria-describedby="button-addon2"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                            />
                            <button
                              className="btn btn-primary text-secondary rounded-0 border-0"
                              type="button"
                              id="button-addon2"
                              onClick={handleSearchClick}
                            >
                              <span className="point-20">
                                <img src={searchIcon} alt="icon" />
                              </span>
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-3">
                          <div className="input-group mb-3">
                            <input
                              type="button"
                              className="form-control btn btn-link text-uppercase me-2 text-danger text-start"
                              placeholder="Reset"
                              aria-label="Reset"
                              value="Reset"
                              onClick={() => handleReset()}
                              aria-describedby="basic-addon1"
                            />
                          </div>
                        </div>

                        {categoryObject && (
                          <div className="clearfix">
                            <span className="float-end">
                              <span className="point-12 text-black-50 fw-light d-flex align-items-center">
                                <span className="point-18 text-black-50 fw-light mb-2 me-2">
                                  {isLoading ? (
                                    <div className="loader">
                                      <img src={loader} alt="loading" />
                                    </div>
                                  ) : !isAddOnDashboard ? (
                                    <i
                                      className="bi bi-star fs-6"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        addToDashboardApi(
                                          categoryObject.label.toLowerCase()
                                        )
                                      }
                                    ></i>
                                  ) : (
                                    <img
                                      src={favoriteImg}
                                      alt="fav"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        addToDashboardApi(
                                          categoryObject.label.toLowerCase()
                                        )
                                      }
                                    />
                                  )}
                                </span>
                                <span className="text-uppercase fw-bold">
                                  Save to Dashboard
                                </span>
                              </span>
                            </span>
                          </div>
                        )}
                        {/* <div className="col">
                          <div className="clearfix">
                            <span className="float-md-end">
                              <span className="point-12 text-black-50 fw-light">
                                <span className="point-18">
                                  <i className="bi bi-star fs-6"></i>
                                </span>
                                <span className="text-uppercase fw-bold">
                                  &nbsp;Save to Dashboard
                                </span>
                              </span>
                            </span>
                          </div>
                        </div> */}
                      </div>
                      <div className="">
                        <ul className="list-group py-3">
                          {!showloader ? (
                            desingList.length > 0 ? (
                              desingList.map((data, i) => (
                                <li
                                  key={data.project_id}
                                  className="list-group-item slideup-p py-3 mb-3 bg-light border border-1 rounded-0 cursor-pointer"
                                >
                                  <div className="d-md-flex justify-content-between align-items-start">
                                    <div className="me-auto mb-2">
                                      <span className="fw-bold point-22">
                                        {data.project_title}&nbsp;
                                      </span>
                                      <span className="point-22 text-black-50 fw-light mb-2">
                                        {data?.favorites === "0" ? (
                                          <i
                                            className="bi bi-star fs-6"
                                            onClick={() =>
                                              addFav(
                                                data?.project_id,
                                                data?.favorites
                                              )
                                            }
                                          ></i>
                                        ) : (
                                          <img
                                            src={favoriteImg}
                                            alt="fav"
                                            onClick={() =>
                                              addFav(
                                                data?.project_id,
                                                data?.favorites
                                              )
                                            }
                                          />
                                        )}
                                      </span>
                                    </div>
                                    <div className="mb-2">
                                      <div className="mb-2">
                                        {data.download_url ? (
                                          <a
                                            className="badge bg-secondary text-decoration-none text-primary rounded-pill text-uppercase py-1 px-3 fw-semibold point-16"
                                            href={data.download_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                          >
                                            Scope of Work
                                          </a>
                                        ) : (
                                          <span className="badge bg-secondary text-decoration-none text-primary rounded-pill text-uppercase py-1 px-3 fw-semibold point-16">
                                            Scope of Work
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <p className="lh-lg">
                                    <span className="fw-bold">DBE Goal:</span>{" "}
                                    {data.dbe_goal}% <br />
                                    {data.date_entered &&
                                      data.estimated_end_date && (
                                        <>
                                          <span className="fw-bold">
                                            Open Date:
                                          </span>{" "}
                                          {getFormattedDate(data.date_entered)}
                                          <span className="text-danger fw-bolder">
                                            &nbsp;|&nbsp;
                                          </span>
                                          <span className="fw-bold">
                                            Close Date:
                                          </span>{" "}
                                          {getFormattedDate(
                                            data.estimated_end_date
                                          )}
                                          <br />
                                        </>
                                      )}
                                    {data.worktypeLabels && (
                                      <>
                                        <span className="fw-bold">
                                          Work Types:
                                        </span>{" "}
                                        {data.worktypeLabels}
                                        <br />
                                      </>
                                    )}
                                    {data.description && (
                                      <>
                                        <span className="fw-bold">
                                          Description:
                                        </span>{" "}
                                        {data.description}
                                        <br />
                                      </>
                                    )}
                                    {!data?.flag_optin ? (
                                      <span
                                        className="fw-bold text-decoration-underline text-secondary view-link"
                                        onClick={() =>
                                          handleModelOpenOptIN(
                                            data?.callid,
                                            data?.project_id
                                          )
                                        }
                                      >
                                        Subs/Suppliers: Opt In
                                      </span>
                                    ) : (
                                      <span className="fw-bold text-secondary">
                                        Subs/Suppliers: Opt In
                                      </span>
                                    )}
                                    <span className="text-danger fw-bolder d-none d-md-inline-block">
                                      &nbsp;|&nbsp;
                                    </span>
                                    <br className="d-block d-md-none" />
                                    <span
                                      className="text-decoration-underline text-secondary view-link"
                                      onClick={() =>
                                        handleModelOpenSeeRecords(
                                          data?.callid,
                                          data?.project_id
                                        )
                                      }
                                    >
                                      See{" "}
                                      <span className="fw-bold">
                                        {data?.count_optin}
                                      </span>{" "}
                                      Opt-in Records
                                    </span>
                                    <span className="text-danger fw-bolder d-none d-md-inline-block">
                                      &nbsp;|&nbsp;
                                    </span>
                                    <br className="d-block d-md-none" />
                                    {!data?.flag_prime_advertise ? (
                                      <span
                                        className="fw-bold text-decoration-underline text-secondary view-link"
                                        onClick={() =>
                                          handleModelOpenAdvertiseForHelp(
                                            data?.callid,
                                            data?.project_id
                                          )
                                        }
                                      >
                                        &nbsp;Primes: Advertise for help
                                      </span>
                                    ) : (
                                      <span className="fw-bold text-secondary">
                                        &nbsp;Primes: Advertise for help
                                      </span>
                                    )}
                                    <span className="text-danger fw-bolder d-none d-md-inline-block">
                                      &nbsp;|&nbsp;
                                    </span>
                                    <br className="d-block d-md-none" />
                                    <span className="fw-bold ">
                                      {data?.count_prime_advertise || 0}
                                    </span>{" "}
                                    <span
                                      className="text-decoration-underline text-secondary view-link"
                                      onClick={() =>
                                        handleModelOpenPrimeContractorHelpModel(
                                          data?.project_id,
                                          data?.callid
                                        )
                                      }
                                    >
                                      Prime contractors looking for help
                                    </span>
                                  </p>
                                </li>
                              ))
                            ) : (
                              <div className="d-md-flex justify-content-center">
                                No Data Found.
                              </div>
                            )
                          ) : (
                            <div className="loader">
                              <img src={loader} alt="loading" />
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      pageLimit={pageLimit}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {modelOpenOptIN && (
            <OptInModel
              open={modelOpenOptIN}
              project_id={selectedProjectId}
              // callId={selectedData}
              handleClose={handleModelCloeseOpenOptIN}
              handleAPIcall={handleAPIcall}
              type="PROJECT"
              endPoint={process.env.REACT_APP_GET_ADD_PROJECT_OPTIN}
            />
          )}

          {modelOpenViewPlan && (
            <ViewPlanHolderModel
              open={modelOpenViewPlan}
              handleClose={handleModelCloseViewPlan}
              callId={selectedData}
            />
          )}
          {/* {modelOpenOptIN && (
              <OptInModel
                open={modelOpenOptIN}
                ccnCallId={selectedProjectId}
                callId={selectedData}
                handleClose={handleModelCloeseOpenOptIN}
                handleAPIcall={handleAPIcall}
              />
            )} */}
          {modelSeeRecords && (
            <SeeRecordsModel
              open={modelSeeRecords}
              project_id={selectedProjectId}
              callId={selectedData}
              handleClose={handleModelCloeseSeeRecords}
              endPoint={process.env.REACT_APP_GET_GET_PROJECT_OPTIN}
              type="PROJECT"
            />
          )}
          {modelAdvertiseForHelp && (
            <AdvertiseForHelpModel
              open={modelAdvertiseForHelp}
              handleClose={handleModelCloeseAdvertiseForHelp}
              callId={selectedData}
              project_id={selectedProjectId}
              handleAPIcall={handleAPIcall}
              endPoint={
                process.env.REACT_APP_GET_ADD_ADVERTISE_FOR_HELP_PROJECT
              }
              type="PROJECT"
            />
          )}
          {PrimeContractorHelp && (
            <PrimeContractorHelpModel
              open={PrimeContractorHelp}
              callId={selectedData}
              project_id={selectedProjectId}
              handleClose={handleModelCloesePrimeContractorHelp}
              endPoint={process.env.REACT_APP_GET_PRIME_ADVERTISE_PROJECT}
              type="PROJECT"
            />
          )}
        </>
      )}
      {activeTab === 1 && <UploadingRequest />}
      <Footer />
    </>
  );
}
export default DesignBuildPage;
